<template>
    <div id="app">
        <div class="word-place">
            <h2>单词</h2>
            <input type="text" v-model="word" placeholder="请输入你的单词">
            <p>{{ word }}</p>
            <p class="warning">{{ warning }}</p>
            <button @click="mainFun">确定</button>
            <h2>翻译</h2>
            <div v-if="!loading" class="audio-place">
                <p>{{ translate }}</p>
                <img src ='../../static/images/play.png' @click="playAudio"/>
                <audio :src="audioSrc" id="audio"></audio>
            </div>
        </div>
        <div class="video-place">
            <h2>视频</h2>
            <div v-if="loading">
                <p>视频生成中,请稍候…</p>
            </div>
            <div v-else>
                <video :src="videoSrc" :poster="poster" :controls="controls" autoplay width="512" height="512" id="singleVideo" v-bind:playbackRate="0.5"></video>
            </div>
            <!-- <video :src="videoSrc" :poster="poster" :controls="controls" autoplay width="512" height="512" id="singleVideo"></video> -->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            word: '',
            warning: '',
            translate: '',
            loading: false,
            // videoSrc: 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'
            videoSrc: '',
            audioSrc: '',
            controls: false,
            poster: 'https://imgres.tujixiazai.com/tujixiazai/27/133738-202204011655126246bdf0800a0.jpg'
        }
    },
    methods: {
        mainFun() {
            // this.loading = true
            this.warning = ''
            var res = this.isWord()
            if (res === false) {
                return
            }
            this.loading = true
            this.wordTranlate()
        },
        isWord() {
                var pattern = /^[a-zA-Z]+$/
                if (this.word === '') {
                    // console.log('空')
                    this.warning = '请输入单词'
                    this.translate = ''
                    this.videoSrc = ''
                    this.controls = false
                    return false
                } else {
                    if (pattern.test(this.word)) {
                        // console.log('是单词')
                        // this.warning = this.word + '是一个单词'
                    } else {
                        // console.log('不是单词')
                        this.warning = this.word + '不是一个单词'
                        return false
                    }
                }
        },
        wordTranlate() {
            // var url = 'https://autumnfish.cn/api/joke/list?num=3'
            var url = 'https://back.bvvd.icu:3002/'
            this.$http.post(url, { text: this.word }, {headers: { 'Content-Type': 'application/json' }}).then((res) => {
                // console.log(res.data.videoUrl)
                // console.log(res.data.translate)
                // console.log(res.data)
                this.loading = false
                if (res.data.code === 3) {
                    this.warning = '音标生成失败'
                    this.controls = false
                    this.controls = false
                    this.translate = ''
                    this.videoSrc = ''
                    this.audioSrc = ''
                } else if (res.data.code === 2) {
                    this.warning = '视频生成失败，服务器内部错误'
                    this.controls = false
                    this.controls = false
                    this.translate = ''
                    this.videoSrc = ''
                    this.audioSrc = ''
                } else if (res.data.code !== 0) {
                    this.warning = '视频生成失败，请检查单词是否正确'
                    this.translate = ''
                    this.videoSrc = ''
                    this.audioSrc = ''
                } else {
                    this.warning = ''
                    this.controls = true
                    this.translate = res.data.translate
                    this.videoSrc = res.data.videoUrl
                    this.audioSrc = res.data.audioUrl
                }
                this.loading = false
            }).catch((err) => {
                console.log(err)
                this.loading = false
                this.warning = '服务器请求失败，请检查网络'
                this.translate = ''
                this.videoSrc = ''
                this.audioSrc = ''
            })
        },
        playAudio() {
            var audio = document.getElementById('audio')
            audio.play()
        }
    }
}
</script>

<style scoped>
#app{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
}
.warning {
    color: red;
}
.word-place {
    width: 50%;
    float: left;
    /* background-color: blue; */
}
.word-place > input {
    width: 85%;
    height: 30px;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 0 10px;
}
.word-place > button {
    width: 50%;
    height: 30px;
    border-radius: 15px;
    border: 1px solid #ccc;
    background-color: #f5f5f5;
    margin-top: 10px;
    text-align: center;
}
.word-place > p  {
    margin-top: 10px;
}
.word-place > h2 {
    margin-top: 20px;
}
.video-place {
    width: 50%;
    float: left;
    /* background-color: aquamarine; */
}
#singleVideo {
    margin-top: 20px;
    border-radius: 15px;
    background-color: #f5f5f5;
}
input:focus {
    outline: none;
    transform: scale(1.05);
}
button:active {
    outline: none;
    background-color: rgb(235, 240, 230);
    transform: scale(1.05);
}
.audio-place{
    display: flex;
    width: fit-content;
    margin: 0 auto;
    background-color: azure;
    border-radius: 15px;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
}
.audio-place> img {
    width: 30px;
    height: 30px;
    margin-top: 30px;
    margin-right: 30px;
    /* padding: 15px; */
    cursor: pointer;
}
.audio-place > p {
    margin-top: 20px;
    margin-left: 20px;
    padding: 15px;
}
audio {
    margin-top: 20px;
    border-radius: 15px;
    background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/user_words.vue